var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_AudienceSettings_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_AudienceSettings_Delete_Body"
          ),
          brickTitle:
            _vm.resource("JourneyComposer_BrickSettingsAudience_Title") +
            " " +
            _vm.resource("JourneyComposer_BrickSettingsBase_Title")
        },
        brick: _vm.brick,
        name: _vm.newName
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.saveSettings()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("settings-item", {
        attrs: {
          icon: "fas fa-user-friends",
          label: _vm.resource(
            "JourneyComposer_BrickSettingsAudience_Audience_DisplayName"
          )
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      label: "name",
                      options: _vm.audiences,
                      disabled: !_vm.canWrite,
                      clearable: false,
                      searchable: "",
                      filterable: ""
                    },
                    model: {
                      value: _vm.selectedAudience,
                      callback: function($$v) {
                        _vm.selectedAudience = $$v
                      },
                      expression: "selectedAudience"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }